import { useState } from 'react'

import {
  ayeApi,
  DetectFaceResponse,
  RegisterCredentialsResponse,
} from '../core'

import useGuardedCallback, { GuardedReturn } from '../utils/useGuardedCallback'
// import { VerifyConsentResponse } from '../core/api/http-methods/verify-consent'

export type ColorsTypes = 'green' | 'yellow' | 'orange'
export type UseAyeProps = object

export type SetupAccountProps = {
  store_id: string
  device_id: string
  email: string
  password: string
}
export function useAye(): {
  detectedFace: string | undefined
  setDetectedFace: React.Dispatch<React.SetStateAction<string | undefined>>
  // deviceReady?: {type: StoreType; token: string; ws: WebSocket};
  // getStarted: () => void;
  face?: DetectFaceResponse
  setUserPin: React.Dispatch<React.SetStateAction<number[]>>
  consent?: RegisterCredentialsResponse
  // open_gate: (pin: number[]) => Promise<GuardedReturn<OpenGateResponse>>;
  // suggestions: ItemType[] | undefined;
  // setSuggestions: React.Dispatch<React.SetStateAction<ItemType[] | undefined>>;
  // orderDetails: SubmitOrderResponse | undefined;
  // pay_order: (pin: number[]) => Promise<GuardedReturn<PayOrderResponse>>;
  // verifyConsent: (
  //   token: string,
  // ) => Promise<GuardedReturn<VerifyConsentResponse>>
  /* The `setOrderDetails` function is a React state setter function that is used to update the value of
the `orderDetails` state variable. It takes an argument of type
`React.SetStateAction<SubmitOrderResponse | undefined>`, which can be either a new value of type
`SubmitOrderResponse` or `undefined`. When called, it updates the value of `orderDetails` to the new
value provided. */
  // setOrderDetails: React.Dispatch<
  //   React.SetStateAction<SubmitOrderResponse | undefined>
  // >;
  setFace: React.Dispatch<React.SetStateAction<DetectFaceResponse | undefined>>
  // ws: React.MutableRefObject<WebSocket | undefined>;
  setConsent: React.Dispatch<
    React.SetStateAction<RegisterCredentialsResponse | undefined>
  >
  userPin: number[]
  loading: boolean
  selectedOptions: { option_1: number; option_2: number } | undefined
  setSelectedOptions: React.Dispatch<
    React.SetStateAction<
      | {
          option_1: number
          option_2: number
        }
      | undefined
    >
  >
  // applyVoucher: ({voucher}:Pick<SubmitOrderRequest["body"],"voucher">) => Promise<
  // GuardedReturn<SubmitOrderResponse>
} {
  const [face, setFace] = useState<DetectFaceResponse>()
  const [userPin, setUserPin] = useState<number[]>([])
  const [detectedFace, setDetectedFace] = useState<string>()
  const [consent, setConsent] = useState<RegisterCredentialsResponse>()
  // const [suggestions, setSuggestions] = useState<ItemType[]>();
  // const [orderDetails, setOrderDetails] = useState<SubmitOrderResponse>();
  const [loading, setLoading] = useState<boolean>(false)
  const [selectedOptions, setSelectedOptions] = useState<{
    option_1: number
    option_2: number
  }>()

  // const verifyConsent = useGuardedCallback(
  //   async (token: string) => {
  //     const headers = new Headers()
  //     console.log('====================================')
  //     console.log({ token })
  //     console.log('====================================')
  //     // headers.append('Authorization', `Bearer ${token}`);
  //     const response = await ayeApi.verifyConsent({
  //       body: {
  //         token,
  //         phoneNumber: consent!.phone_number!,
  //         method: 'registration',
  //       },
  //       headers,
  //     })
  //     return response
  //   },
  //   [face, consent],
  // )

  return {
    detectedFace,
    setDetectedFace,
    face,
    setUserPin,
    consent,
    setFace,
    setConsent,
    userPin,
    loading,
    selectedOptions,
    // verifyConsent,
    setSelectedOptions,
  }
}
